<template>
  <div class="page" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row :gutter="20">
      <el-col :xs="12" :sm="6" :md="6" :lg="5" :xl="4">
        <div v-for="(item, index) in contents" class="index-item" :class="{ active: currIndex === index }" :key="item.id" @click="currIndex = index">
          <p>{{ item.name }}</p>
        </div>
      </el-col>
      <el-col :xs="24" :sm="18" :md="18" :lg="19" :xl="20">
        <div class="content">
          <template v-for="item in contents[currIndex].list">
            <p class="title" :key="item.id + 'title'" @click="item.show = !item.show">Q: {{ item.title }}</p>
            <div v-if="item.show" class="desc" :key="item.id + 'desc'" v-html="item.content"></div>
            <video :key="item.id + 'video'" v-if="item.url && item.show" :src="item.url" controls></video>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getFaqAll } from '../../api/system';

export default {
  name: 'Faq',
  data() {
    return {
      fullscreenLoading: false,
      contents: [],
      currIndex: 0,
    };
  },
  created() {
    getFaqAll().then((res) => {
      if (res.status === 1) {
        this.contents = (res.data || []).map((item) => {
          item.list = (item.list || []).map((sitem) => {
            sitem.show = true;
            return sitem;
          });
          return item;
        });
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.index-item {
  padding: 15px 10px;
  margin-bottom: 10px;
  text-align: center;
  background-color: #fff;
  border-radius: 5px;
  cursor: pointer;
  user-select: none;

  &.active {
    background-color: rgba($color: #0a0d11, $alpha: 0.1);
  }
}
.content {
  padding: 15px 20px;
  background-color: #fff;
  border-radius: 5px;

  .title {
    margin-bottom: 10px;
    font-size: 18px;
    cursor: pointer;
  }
  .desc {
    margin-bottom: 20px;
    & + .title {
      margin-top: 25px;
    }
  }
  video {
    display: block;
    max-width: 100%;

    & + .title {
      margin-top: 25px;
    }
  }
  img {
    max-width: 100%;
  }
}
</style>
<style>
.ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.ql-align-center {
  text-align: center;
}
.ql-align-justify {
  text-align: justify;
}
.ql-align-right {
  text-align: right;
}
</style>
